<template>
  <!-- 提问 -->
  <div>
     <h3 style="margin-bottom: 10px;margin-top:30px" v-if="courseName">{{courseName}}</h3>
    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="120px" size="mini">
            <el-row>
              <el-col :span="6">
                <el-form-item prop="batch" label="开课批次/班级编码：">
                  <el-input size="small" v-model="form.batch"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="teacher" label="任课老师：">
                  <el-input size="small" v-model="form.teacher"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="school" label="开课机构：">
                  <el-input size="small" v-model="form.school"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="isVerify" label="审核状态：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.isVerify"
                    placeholder="-不限-"
                    size="small"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in auditList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item prop="courseStatus" label="课程状态：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.courseStatus"
                    placeholder="-不限-"
                    size="small"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in classList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="isOpen" label="公开状态：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.isOpen"
                    placeholder="-不限-"
                    size="small"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in publicList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="fullname" label="姓名：">
                  <el-input size="small" v-model="form.fullname"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="search">
                  确定
                </el-button>
                <el-button size="mini" @click="toggle">收起</el-button>
                <el-button size="mini" @click="delAll"> 清空 </el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="toggle">筛选</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
      @sort-change="sortChange"
    >
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column
        label="序号"
        width="50"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">{{
          scope.$index + 1 + (pageObj.page - 1) * pageObj.pageSize
        }}</template>
      </el-table-column>
      <el-table-column prop="content" label="问题描述" align="center">
      </el-table-column>
      <el-table-column
        prop="isOpen"
        label="公开状态"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="videoTitle"
        label="课程名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="batch"
        label="开课批次/班级编码"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="teacher"
        label="任课老师"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="school"
        label="开课机构"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="courseStatus"
        label="课程状态"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="uname"
        label="提问者"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="fullname"
        label="姓名"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="qstCommentCount"
        label="回答数量"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="isVerify"
        label="审核状态"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="uname"
        label="操作"
        width="200"
        header-align="center"
      >
        <template slot-scope="scope">
          <div class="table_control">
            <span
              class="table_control_item"
              @click="
                replay(
                  scope.row.content,
                  scope.row.id,
                  scope.row.oid,
                  scope.row.replyUid,
                  scope.row.batchId
                )
              "
              >回复</span
            >
            |
            <span
              class="table_control_item"
              @click="lookAnswer('1', scope.row.id, scope.row.videoTitle )"
              >查看回答</span
            >
            |
            <span
              v-if="scope.row.sort == 0"
              class="table_control_item"
              @click="onTop('0', scope.row.id)"
              >置顶</span
            >
            <span
              v-else
              class="table_control_item"
              @click="onTop('1', scope.row.id)"
              >取消置顶</span
            >
            |
            <span class="table_control_item" @click="deleteAswer(scope.row.id)"
              >删除</span
            >
            |
            <span
              class="table_control_item"
              @click="auditPass(scope.row.isVerify, scope.row.id)"
              >审核通过</span
            >
            |
            <span
              class="table_control_item"
              @click="noAudit(scope.row.isVerify, scope.row.id)"
              >审核不通过</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>

    <!-- 回复弹窗 -->
    <el-dialog
      title="回复"
      :visible.sync="dialogVisible"
      width="800px"
      @close="cancel"
    >
      <el-form
        :model="dolform"
        ref="dolform"
        label-width="80px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="问题描述" prop="question">
              <el-input
                type="textarea"
                :rows="1"
                resize="none"
                autosize
                v-model="dolform.question"
                disabled
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-input
              type="textarea"
              :rows="3"
              v-model="dolform.replay"
            ></el-input>
          </el-col>
        </el-row>
      </el-form>
      <!-- 操作部分 -->
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center"
      >
        <el-button type="primary" @click="onReplay"> 回复 </el-button>
        <el-button @click="cancel">取消</el-button>
      </span>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog
      title="审核原因"
      :visible.sync="dialogAudit"
      width="800px"
      @close="cancel"
    >
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="不通过原因" prop="question">
          <el-input
            type="textarea"
            :rows="1"
            resize="none"
            autosize
            v-model="auditNoPass"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="快捷回复">
          <el-checkbox v-model="checked" @change="handleCheckChange"
            >与课程无关</el-checkbox
          >
        </el-form-item>
      </el-form>
      <!-- 操作部分 -->
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center"
      >
        <el-button type="primary" @click="notAudit"> 确定 </el-button>
        <el-button @click="cancel">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from "@/api/TeacherClassroomManagement/MyClassroomTution/proposeQuestion";
export default {
  data() {
    return {
      // batchId: this.$route.query.batchId,
      courseId: this.$route.query.courseId,
      courseName:this.$route.query.courseName,
      aswerType: '1', // 用于区分返回提问列表
      activeNames: [],
      //   检索参数
      form: {
        batch: "",
        teacher: "",
        school: "",
        isVerify: "",
        courseStatus: "",
        isOpen: "",
        fullname: "",
      },
      dolform: {
        question: "",
        replay: "",
      },
      dialogVisible: false,
      // 驳回
      dialogAudit: false,
      // 不通过原因
      auditNoPass: "",
      checked: false,
      noAuditId: "",
      //  回复参数
      replayParams: {
        parentId: "",
        oid: "",
        replyUid: "",
        batchId: "",
      },
     auditList: [
        { label: "-不限-", value: "" },
        { label: "审核通过", value: "1" },
        { label: "审核不通过", value: "2" },
        { label: "待审核", value: "0" },
      ],
      classList: [
        { label: "-不限-", value: "" },
        { label: "开课中", value: "1" },
        { label: "未开课", value: "2" },
        { label: "已结课", value: "3" },
        { label: "未配置", value: "4" },
        { label: "已取消", value: "5" },
      ],
      publicList: [
         { label: "-不限-", value: "" },
        { label: "公开", value: "1" },
        { label: "不公开", value: "0" },
      ],
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      selectedList: [],
    };
  },
  computed: {
    getUId() {
      return localStorage.getItem("uid");
    },
    url() {
      let url = window.location.protocol + "//" + window.location.host;
      if (window.location.host == "localhost:5001") {
        url = "http://gz.hnjk.net";
      }
      return url;
    },
  },
  created() {
    this.getQuestionList();
  },
  beforeDestroy() {
    window.removeEventListener("keyup", this.enterQuery);
  },
  methods: {
    async getQuestionList() {
      const { data, code } = (
        await api.getQuestionList({
          // 后续需要改回动态参数
          oid: this.courseId, // 测试课程id  911,
          uid: localStorage.getItem('uid'), // 测试uid 1 ,
          ...this.form,
          ...this.pageObj,
        })
      ).data;
      if (code === 100000) {
        console.log("提问列表", data);
        this.tableData = data.list;
        this.total = data.total;
      }
    },

    //搜索的折叠面板
    toggle() {
      if (this.activeNames.length > 0) {
        this.activeNames = [];
        window.removeEventListener("keyup", this.enterQuery);
      } else {
        this.activeNames = ["1"];
        window.addEventListener("keyup", this.enterQuery);
      }
    },
    // 检索
    search() {
      this.pageObj.page = 1;
      this.getQuestionList();
    },
    enterQuery(e) {
      if (e.key === "Enter") {
        this.search();
      }
    },
    // 删除
    delAll() {
      this.$refs.form.resetFields();
      this.pageObj.page = 1;
      this.getQuestionList();
    },
    addStudents() {
      this.$emit("addStudents");
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val;
      this.getQuestionList();
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val;
      this.getQuestionList();
    },
    // 下拉改变触发
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur();
      }
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr;
    },
    goLearningOutcome() {
      this.$emit("goLearningOutcomeFromStudent");
    },
    sortChange({ column, prop, order }) {},
    // 回复弹窗
    replay(des, id, oid, replyUid, batchId) {
      this.dialogVisible = true;
      // 问题描述参数赋值
      this.dolform.question = des;
      this.replayParams.parentId = id;
      this.replayParams.oid = oid; // 课程id oid
      this.replayParams.replyUid = replyUid; // 回复人id replyUid
      this.replayParams.batchId = batchId; // 批次id batchId
    },
    // 回复确定
    onReplay() {
      this.getReplyQuestion();
    },
    // 回复请求
    async getReplyQuestion() {
      if(!this.dolform.replay){
        this.$message({
          message: "请填写回复内容",
          type: "error",
        });
        return
      }
      const params = {
        parentId: this.replayParams.parentId, // 提问人id parentId
        oid: this.replayParams.oid, // 课程id oid
        replyUid: this.replayParams.replyUid, // 回复人id replyUid
        batchId: this.replayParams.batchId, // 批次id batchId
        uid: localStorage.getItem('uid'),  // 用户id uid  测试uid 1
        content: this.dolform.replay, // 回复内容 content
      };
      console.log("params==>", params);
      const { code, msg } = (await api.getReplyQuestion(params)).data;
      if (code === 100000) {
        this.$message({
          message: "回复成功",
          type: "success",
        });
        this.dialogVisible = false
        //  需要重新调用列表接口
        this.getQuestionList();
      } else {
        this.$message.error(msg);
      }
    },
    // 查看回答
    lookAnswer(tab, id, videoTitle) { 
      this.$router.push(
        `/LookQuestion?tab=${tab}&id=${id}&batchId=${this.batchId}&courseId=${this.courseId}&activeName=${videoTitle}&aswerType=${this.aswerType}`
      );
    },
    // 置顶
    onTop(tab, id) {
      // 置顶
      if (tab == "0") {
        let params = {
          id: id,
          sort: 999,
        };
        this.getSortQuestion(params);
      } else if (tab == "1") {
        // 取消置顶
        let params = {
          id: id,
          sort: 0,
        };
        this.getSortQuestion(params);
      }
    },
    // 置顶请求
    async getSortQuestion(params) {
      const { code, msg } = (await api.getSortQuestion(params)).data;
      if (code === 100000) {
        if (params.sort == 0) {
          this.$message({
            message: "已取消置顶",
            type: "success",
          });
        } else {
          this.$message({
            message: "已置顶",
            type: "success",
          });
        }

        //  需要重新调用列表接口
        this.getQuestionList();
      } else {
        this.$message.error(msg);
      }
    },
    // 删除
    deleteAswer(id) {
      this.getdelQuestion(id);
    },
    // 删除请求
    async getdelQuestion(id) {
      const { code, msg } = (
        await api.getdelQuestion({
          ids: id,
        })
      ).data;
      if (code === 100000) {
        this.$message({
          message: "删除成功",
          type: "success",
        });
        //  需要重新调用列表接口
        this.getQuestionList();
      } else {
        this.$message.error(msg);
      }
    },
    // 通过
    auditPass(isVerify, id) {
      console.log(isVerify);
      if (isVerify == "审核通过") {
        this.$message({
          message: "审核已通过",
          type: "success",
        });
      } else {
        this.getVerifyQuestion(id);
      }
    },
    // 审核通过
    async getVerifyQuestion(id) {
      const { code, msg } = (
        await api.getVerifyQuestion({
          id: id, // 需要动态获取
          isVerify: 1,
        })
      ).data;
      if (code === 100000) {
        console.log(data);
        //  需要重新调用列表接口
        this.getQuestionList();
      } else {
        this.$message.error(msg);
      }
    },
    // 复选框处理
    handleCheckChange(val) {
      console.log(val);
      if (val == false) {
        this.auditNoPass = "";
      }
      if (val == true && this.auditNoPass == "") {
        this.auditNoPass = "与课程无关";
      } else {
        this.auditNoPass = this.auditNoPass;
      }
    },
    // 审核不通过
    noAudit(isVerify, id) {
      if (isVerify == "审核通过") {
        this.$message({
          message: "审核已通过，不能修改",
          type: "warning",
        });
      } else {
        this.dialogAudit = true;
        this.noAuditId = id;
        console.log(this.noAuditId);
      }
    },
    notAudit() {
      this.getNoVerifyQuestion();
    },
    // 审核不通过
    async getNoVerifyQuestion() {
       if(!this.auditNoPass){
        this.$message({
          message: "请填写不通过原因",
          type: "error",
        });
        return
      }
      const { code, msg } = (
        await api.getNoVerifyQuestion({
          id: this.noAuditId, // 需要动态获取
          isVerify: 2,
          nopassReason: this.auditNoPass,
        })
      ).data;
      if (code === 100000) {
        this.dialogAudit = false;
        //  需要重新调用列表接口
        this.getQuestionList();
      } else {
        this.$message.error(msg);
      }
    },
    // 取消
    cancel() {
      this.dialogAudit = false;
      this.dialogVisible = false;
      this.dolform.replay = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/classManagement.scss";
.table_control {
  color: #409eff;
  .table_control_item {
    cursor: pointer;
  }
}
/deep/.el-dialog__header {
  background-color: #d7d7d7;
}
</style>